(function () {
  function init() {
    var section = document.querySelector('.sq-video-slider');
    if (!section) return;

    var track = section.querySelector('[data-vs-track]');
    if (!track) return;
    var tiles = Array.from(track.querySelectorAll('.vs-tile'));
    var n = tiles.length;
    if (n < 1) return;

    var wrap = section.querySelector('.vs-slider-wrap');
    if (!wrap) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    var current = n >= 3 ? 1 : 0;

    var prevBtn = section.querySelector('.vs-arrow--prev');
    var nextBtn = section.querySelector('.vs-arrow--next');

    /* ── Modal elements (queried early so drag code can call openModal) ── */
    var modal = section.querySelector('.vs-modal');
    var modalVideo = modal ? modal.querySelector('.vs-modal-video') : null;
    var modalProduct = modal ? modal.querySelector('.vs-modal-product') : null;
    var modalVariantInput = modal ? modal.querySelector('.vs-modal-variant-input') : null;
    var modalProgressFill = modal ? modal.querySelector('.vs-modal-progress-fill') : null;
    var modalIndex = 0;

    function onModalTimeUpdate() {
      if (!modalProgressFill || !modalVideo.duration) return;
      modalProgressFill.style.width = (modalVideo.currentTime / modalVideo.duration * 100) + '%';
    }

    function onModalEnded() {
      modalIndex = (modalIndex + 1) % n;
      current = modalIndex;
      update(true);
      openModal(tiles[modalIndex]);
    }

    function openModal(tile) {
      if (!modal || !modalVideo) return;
      var videoSrc = tile.dataset.videoSrc;
      if (!videoSrc) return;

      modalIndex = tiles.indexOf(tile);
      modalVideo.removeEventListener('timeupdate', onModalTimeUpdate);
      modalVideo.removeEventListener('ended', onModalEnded);
      if (modalProgressFill) modalProgressFill.style.width = '0';

      modalVideo.innerHTML = '';
      var source = document.createElement('source');
      source.src = videoSrc;
      source.type = 'video/mp4';
      modalVideo.appendChild(source);
      modalVideo.muted = false;
      modalVideo.load();
      modalVideo.addEventListener('timeupdate', onModalTimeUpdate);
      modalVideo.addEventListener('ended', onModalEnded);
      modalVideo.play().catch(function () {});

      var variantId = tile.dataset.variantId;
      var productName = tile.dataset.productName;
      var productPrice = tile.dataset.productPrice;
      var productThumb = tile.dataset.productThumb;
      var productUrl = tile.dataset.productUrl;

      if (variantId && modalProduct) {
        var chipHtml = '';
        if (productThumb) {
          chipHtml += '<img src="' + productThumb + '" alt="" width="36" height="36">';
        }
        chipHtml += '<div class="vs-modal-chip-info">';
        chipHtml += '<div class="vs-modal-chip-name">' + (productName || '') + '</div>';
        if (productPrice) chipHtml += '<div class="vs-modal-chip-price">' + productPrice + '</div>';
        chipHtml += '</div>';

        var chipLink = modalProduct.querySelector('.vs-modal-chip');
        chipLink.href = productUrl || '#';
        chipLink.innerHTML = chipHtml;
        modalProduct.style.display = '';
        if (modalVariantInput) {
          modalVariantInput.value = variantId;
        }
      } else if (modalProduct) {
        modalProduct.style.display = 'none';
      }

      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (!modal || !modalVideo) return;
      modalVideo.removeEventListener('timeupdate', onModalTimeUpdate);
      modalVideo.removeEventListener('ended', onModalEnded);
      modal.classList.remove('open');
      modalVideo.pause();
      modalVideo.innerHTML = '';
      if (modalProgressFill) modalProgressFill.style.width = '0';
      document.body.style.overflow = '';
    }

    function getStep() {
      var tileW = tiles[0].offsetWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return { tileW: tileW, gap: gap, step: tileW + gap };
    }

    function wrapIndex(val) {
      return ((val % n) + n) % n;
    }

    function update(animate) {
      current = wrapIndex(current);

      var m = getStep();
      var viewW = wrap.offsetWidth;
      var padL = parseFloat(getComputedStyle(wrap).paddingLeft) || 0;
      var offset = (viewW - m.tileW) / 2 - padL - current * m.step;

      if (animate && !reducedMotion.matches) {
        track.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
      } else {
        track.style.transition = 'none';
      }
      track.style.transform = 'translateX(' + offset + 'px)';

      tiles.forEach(function (t, idx) {
        t.classList.toggle('is-current', idx === current);
      });

      var arrowTop = wrap.offsetTop + wrap.offsetHeight / 2;
      if (prevBtn) prevBtn.style.top = arrowTop + 'px';
      if (nextBtn) nextBtn.style.top = arrowTop + 'px';
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      current--; update(true);
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      current++; update(true);
    });

    function onArrowKeydown(e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); current--; update(true); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); current++; update(true); }
    }
    if (prevBtn) prevBtn.addEventListener('keydown', onArrowKeydown);
    if (nextBtn) nextBtn.addEventListener('keydown', onArrowKeydown);

    /* ── Pointer interaction: drag-to-slide + tap-to-modal ── */
    var dragStartX = 0;
    var dragStartY = 0;
    var trackStartX = 0;
    var dragging = false;
    var didDrag = false;
    var axisLocked = false;
    var tapTile = null;
    var DRAG_THRESHOLD = 5;
    var SWIPE_THRESHOLD = 50;

    function onPointerDown(e) {
      if (e.target.closest('.vs-product-chip')) return;
      dragging = true;
      didDrag = false;
      axisLocked = false;
      tapTile = e.target.closest('.vs-tile');
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      var matrix = getComputedStyle(track).transform;
      trackStartX = (matrix && matrix !== 'none') ? (parseFloat(matrix.split(',')[4]) || 0) : 0;
      if (e.pointerType !== 'touch') track.setPointerCapture(e.pointerId);
      track.style.transition = 'none';
      if (e.pointerType !== 'touch') track.style.cursor = 'grabbing';
    }

    function onPointerMove(e) {
      if (!dragging) return;
      var dx = Math.abs(e.clientX - dragStartX);
      var dy = Math.abs(e.clientY - dragStartY);
      if (!axisLocked) {
        if (e.pointerType === 'touch') {
          if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
            if (dx > dy) {
              didDrag = true;
              axisLocked = true;
            } else {
              dragging = false;
              return;
            }
          }
        } else if (dx > DRAG_THRESHOLD) {
          didDrag = true;
          axisLocked = true;
        }
      }
      if (didDrag) {
        e.preventDefault();
        track.style.transform = 'translateX(' + (trackStartX + (e.clientX - dragStartX)) + 'px)';
      }
    }

    function onPointerUp(e) {
      if (!dragging) return;
      dragging = false;
      track.style.cursor = '';
      if (didDrag) {
        var delta = e.clientX - dragStartX;
        if (Math.abs(delta) >= SWIPE_THRESHOLD) {
          if (delta < 0) current++;
          else if (delta > 0) current--;
        }
        update(true);
      } else {
        if (tapTile) openModal(tapTile);
      }
      tapTile = null;
    }

    function onPointerCancel() {
      if (!dragging) return;
      dragging = false;
      tapTile = null;
      track.style.cursor = '';
      update(true);
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerCancel);

    window.addEventListener('resize', function () { update(false); });
    update(false);

    /* ── Video autoplay via IntersectionObserver ── */
    var videos = section.querySelectorAll('.vs-tile video');
    if (videos.length) {
      var playObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.15, rootMargin: '200px 0px' });

      videos.forEach(function (v) { playObserver.observe(v); });

      var warmedUp = false;
      function warmUp() {
        if (warmedUp) return;
        warmedUp = true;
        videos.forEach(function (v) { v.preload = 'auto'; v.load(); });
      }
      track.addEventListener('touchstart', warmUp, { once: true, passive: true });
      track.addEventListener('pointerdown', warmUp, { once: true });

      var warmObserver = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { warmUp(); warmObserver.disconnect(); }
      }, { rootMargin: '600px 0px' });
      warmObserver.observe(track);
    }

    /* ── Modal event bindings ── */
    if (modal) {
      var backdrop = modal.querySelector('.vs-modal-backdrop');
      var closeBtn = modal.querySelector('.vs-modal-close');
      var modalPrev = modal.querySelector('.vs-modal-nav--prev');
      var modalNext = modal.querySelector('.vs-modal-nav--next');

      if (modalPrev) modalPrev.addEventListener('click', function () {
        modalIndex = (modalIndex - 1 + n) % n;
        current = modalIndex;
        update(true);
        openModal(tiles[modalIndex]);
      });
      if (modalNext) modalNext.addEventListener('click', function () {
        modalIndex = (modalIndex + 1) % n;
        current = modalIndex;
        update(true);
        openModal(tiles[modalIndex]);
      });

      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      if (backdrop) backdrop.addEventListener('click', closeModal);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('open')) closeModal();
      });

      document.addEventListener('theme:cart:added', function () {
        if (modal.classList.contains('open')) closeModal();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
